exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-sort-list__item{cursor:pointer;list-style:none}.ebx-sort-list__item--selected{font-weight:700}", ""]);
